import { generateDropReportEndpoint, generateDropReportTaskEndpoint } from 'root/src/server/modules/dropReports/endpoints/generateDropReport.endpoint';
export const dropReportsEndpoints = Object.assign(Object.assign({}, generateDropReportEndpoint), generateDropReportTaskEndpoint);
